import { useState } from 'react';
import { subscribeToJobAlerts, getUserSubscription } from '../lib/supabase/subscriptions';
import { useAuth } from '../contexts/AuthContext';

export function useSubscription() {
  const { user } = useAuth();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState(false);

  const subscribe = async (email: string) => {
    setLoading(true);
    setError(null);
    setSuccess(false);

    try {
      await subscribeToJobAlerts(email, user?.id);
      setSuccess(true);
      return true;
    } catch (err) {
      const message = err instanceof Error ? err.message : 'Failed to subscribe';
      setError(message);
      return false;
    } finally {
      setLoading(false);
    }
  };

  const checkSubscription = async () => {
    if (!user) return null;

    try {
      return await getUserSubscription(user.id);
    } catch (err) {
      console.error('Error checking subscription:', err);
      return null;
    }
  };

  return {
    subscribe,
    checkSubscription,
    loading,
    error,
    success,
  };
}
